import uidGenerator from '@utils/UIDGenerator.js'
import { defaultSettings } from '@components/Widgets/_contentItems/_baseTemplate'

const surveyAnswerDefaultTemplate = {
  id: '',
  text: 'I am an example answer',
}

const defaultStyling = {
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontWeight: '400',
    color: 'rgb(0, 0, 0)',
    backgroundColor: 'rgb(255, 255, 255)',
    textAlign: 'center',
    borderRadius: '0px',
    borderWidth: '2px',
    borderColor: '#000000',
  }

const surveyDefaultTemplate = {
  id: '32797909',
  type: 'survey',
  category: 'form',
  content: {
    options: (() => {
      const answersArr = []
      const loopArr = [uidGenerator(), uidGenerator(), uidGenerator()]

      loopArr.forEach((uid, index) => {
        const customAnswer = JSON.parse(JSON.stringify(surveyAnswerDefaultTemplate))
        customAnswer.id = uid
        customAnswer.text = customAnswer.text + ' ' + (index + 1)
        answersArr.push(customAnswer)
      })

      return answersArr
    })(),
  },
  settings: {
    ...defaultSettings,
    required: false,
    label: 'New Survey',
  },
  /*  Keep the styling even in flattened json structure cause vue ease of use */
  styling: { ...defaultStyling },
}

export { surveyDefaultTemplate, surveyAnswerDefaultTemplate, defaultStyling }
